module.exports = __webpack_public_path__ + "img/customerGuide.f31a312b.jpg";